import React, {
  useState, useEffect, useContext,
} from 'react';
import PropTypes from 'prop-types';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import VisibilityIcon from '@material-ui/icons/Visibility';
import IconButton from '@material-ui/core/IconButton';
import { useMediaQuery } from '@material-ui/core';
import { AppContext } from '../AppProvider';
import H3 from '../Text/H3';
import Small from '../Text/Small';
import {
  Container, Label, ToolTipIcon, ToolTipModal,
} from './styled';
import QuestionMarkIcon from './question_mark.svg';

function Input({
  type,
  mask,
  label = '',
  style,
  update = () => { },
  value = '',
  onBlur = () => { },
  max,
  capitalize,
  tooltip,
  tooltipTitle,
  ...other
}) {
  let inputRef;
  const { actions: { showModal } } = useContext(AppContext);
  const mobile = useMediaQuery('(max-width:500px)');
  const [showPassword, setShowPassword] = useState(false);
  const [active, setActive] = useState(false);

  useEffect(() => {
    $(inputRef).on('animationstart', (e) => {
      console.warn('Something changed the input form to:', inputRef.value, 'updating component');
      update(inputRef.value);
      $(this).unbind(e);
    });
    setTimeout(() => {
      if (inputRef && inputRef.value) {
        update(inputRef.value);
      }
    }, 1000);
  });

  useEffect(() => {
    setActive(!!value || document.activeElement === inputRef);
  }, [inputRef, value]);

  const _type = type === 'password' && showPassword ? '' : type;
  return (
    <Container
      onClick={() => (!other.readOnly ? inputRef.focus() : null)}
      style={{ ...style }}>
      <Label for={label} active={active}>
        {label}
      </Label>
      <input
        style={{ textTransform: capitalize ? 'capitalize' : 'unset' }}
        id={label}
        name={label.toLowerCase().trim()}
        type={_type}
        onFocus={() => (!other.readOnly ? setActive(true) : null)}
        ref={ref => {
          inputRef = ref;

          if (inputRef && inputRef.value !== value && !active) {
            inputRef.value = value;
          }
        }}
        onBlur={({ target: { value } }) => {
          if (!value) {
            setActive(false);
          }
          onBlur(value);
        }}
        {...other}
        value={value || null}
        onChange={({ target: { value } }) => {
          let valueAfterMask = value;

          if (mask) {
            valueAfterMask = mask(value);
          } else if (type === 'tel' || type === 'number') {
            valueAfterMask = value.replace(/\D/gi, '');
          }

          if (max) {
            valueAfterMask = valueAfterMask.substr(0, max);
          }

          if (max && valueAfterMask.length === max) {
            // var inputs = $(inputRef).closest('form').find(':input');
            // inputs.eq(inputs.index(inputRef) + 1).focus();
          }
          inputRef.value = valueAfterMask;
          update(valueAfterMask);
        }}
      />
      {tooltip && <ToolTipIcon src={QuestionMarkIcon} onClick={() => {
        showModal(<ToolTipModal>
          <H3 center style={{ marginBottom: 6 }}>{tooltipTitle}</H3>
          <Small style={{ whiteSpace: 'break-spaces' }}>{tooltip}</Small>
        </ToolTipModal>);
      }} />}
      {type === 'password' && <IconButton onClick={() => !mobile && setShowPassword(!showPassword)} onTouchStart={() => mobile && setShowPassword(!showPassword)} disableRipple={true} style={{
        alignSelf: 'center', position: 'absolute', right: 20, top: '50%', transform: 'translate(0, -50%)', WebkitTransform: 'translate(0, -50%)',
      }} size="small">{!showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}</IconButton>}
    </Container>
  );
}

Input.propTypes = {
  /** If used in a form the user cannot continue until all "required" fields are entered. */
  required: PropTypes.bool,
  /** The type of input to display */
  type: PropTypes.oneOf(['tel', 'number']),
  /** @param {String} value - Value after user input */
  update: PropTypes.func,
  /**
   * Used to do processing on the raw user input before returning to display
   * @param {String} value - Value after user input
   * @return {String} processed input
   * */
  mask: PropTypes.func,
  /** The label to show on top of input field  */
  label: PropTypes.string.isRequired,
  /** Value to display in the input */
  value: PropTypes.string,
  /** Called after the input loses focus */
  onBlur: PropTypes.func,
  /** Max length for the input field */
  max: PropTypes.number,
};

export default Input;
